import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "UrlList"
}
const _hoisted_3 = ["title", "href"]
const _hoisted_4 = {
  key: 0,
  class: "lnr-cross closeIcon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isPortalTypeMasters)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['ExpandableContentContainer', {'collapsed-container': !_ctx.expanded}])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['ExpandableContent', {'collapsed': !_ctx.expanded, 'expanded': _ctx.expanded}])
        }, [
          _createElementVNode("div", {
            class: "StaticContent",
            innerHTML: _ctx.text
          }, null, 8 /* PROPS */, _hoisted_1),
          (_ctx.urls.length)
            ? (_openBlock(), _createElementBlock("ol", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (url) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "UrlListItem",
                    key: url.getUrl()
                  }, [
                    _createElementVNode("a", {
                      class: "UrlListItemLink",
                      title: url.getText(),
                      href: url.getUrl(),
                      target: "_blank"
                    }, _toDisplayString(url.getText()), 9 /* TEXT, PROPS */, _hoisted_3)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        _createElementVNode("button", {
          type: "button",
          class: "ReadMoreButton",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-expand')))
        }, [
          _createTextVNode(_toDisplayString(_ctx.expanded ? 'close' : 'read more') + " ", 1 /* TEXT */),
          (_ctx.expanded)
            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
            : _createCommentVNode("v-if", true)
        ])
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}